import { StackedGroupBarChart } from "@jana-technology/platform-ui";

import { useGlobalFiltersContext } from "contexts/filters";
import { useBaseBarChartProps } from "hooks/useBaseBarChartProps";
import { useTotalSystemOverviewCharts } from "hooks/queries";
import { x1Accessor, xAccessor } from "helpers/charts";

import { ChartCard } from "components/charts/ChartCard";
import { TopRiskWellsByThreatIntervention } from "components/charts/TopRiskWellsIntervention";
import { InterventionCardHeading } from "components/headings";
import { ChartsLayout } from "layouts/ChartsLayout";

export const SystemOverviewInterventionCharts = () => {
  const { hierarchyIdsOverview } = useGlobalFiltersContext();

  const totalSystemOverviewCharts = useTotalSystemOverviewCharts({
    variables: { hierarchyIds: hierarchyIdsOverview },
  });

  const baseBarChartProps = useBaseBarChartProps();

  return (
    <ChartsLayout>
      <ChartCard
        loading={totalSystemOverviewCharts.loading}
        heading={<InterventionCardHeading heading="Risk by Threat" />}
      >
        <StackedGroupBarChart
          {...baseBarChartProps}
          chartName="Risk by Threat"
          xAccessor={xAccessor}
          x1Accessor={x1Accessor}
          yMaxStackVal={totalSystemOverviewCharts.yMaxStackVal}
          data={totalSystemOverviewCharts.threatIRTab}
          dataKeys={totalSystemOverviewCharts.threatIRDataKeys}
          annotationsValues={totalSystemOverviewCharts.totals}
        />
      </ChartCard>
      <ChartCard
        loading={totalSystemOverviewCharts.loading}
        heading={<InterventionCardHeading heading="Risk by Consequence" />}
      >
        <StackedGroupBarChart
          {...baseBarChartProps}
          chartName="Risk by Consequence"
          xAccessor={xAccessor}
          x1Accessor={x1Accessor}
          yMaxStackVal={totalSystemOverviewCharts.yMaxStackVal}
          data={totalSystemOverviewCharts.consequenceIRTab}
          dataKeys={totalSystemOverviewCharts.consequenceIRDataKeys}
          annotationsValues={totalSystemOverviewCharts.totals}
        />
      </ChartCard>
      <ChartCard
        loading={totalSystemOverviewCharts.loading}
        heading={<InterventionCardHeading heading="Risk by Outcome Scenario" />}
      >
        <StackedGroupBarChart
          {...baseBarChartProps}
          chartName="Risk by Outcome Scenario"
          xAccessor={xAccessor}
          x1Accessor={x1Accessor}
          yMaxStackVal={totalSystemOverviewCharts.yMaxStackVal}
          data={totalSystemOverviewCharts.outcomeIRTab}
          dataKeys={totalSystemOverviewCharts.outcomeIRDataKeys}
          annotationsValues={totalSystemOverviewCharts.totals}
        />
      </ChartCard>
      <TopRiskWellsByThreatIntervention />
    </ChartsLayout>
  );
};

export default SystemOverviewInterventionCharts;
